/**
 * cnbConfig.shortCut.useCustomSort: false => SHORTCUT에서 정의된 순서
 * cnbConfig.shortCut.useCustomSort: true => cnbConfig.shortCut에서 정의된 순서
 */

import { NETWORK, NSHOP_COUPON_DOMAIN } from "./index";

export const SHORTCUT = {
    CHAR_HOME: { key: 'charHome', l10nKey: 'CharacterHome', iconClass: 'home' },
    MYPAGE: { key: 'mypage', l10nKey: 'MyPage' },
    MYNHSOP: { key: 'mynshop', l10nKey: 'MyNShop' },
    NCOIN: { key: 'ncoin', l10nKey: 'NCoin' },
    ENTER_COUPON: { key: 'enterCoupon', l10nKey: 'EnterCoupon', iconClass: 'entercoupon' },
    COUPON: { key: 'coupon', l10nKey: 'Coupon' },
    COUPON_GAME: { key: 'couponGame', l10nKey: 'Coupon', iconClass: 'coupon' },
    NPOINT: { key: 'npoint', l10nKey: 'NPoint' },
    NPOINT_GAME: { key: 'npointGame', l10nKey: 'NPoint', iconClass: 'npoint' },
    GIFT: { key: 'gift', l10nKey: 'Gift' },
    TICKET: { key: 'ticket', l10nKey: 'Ticket' },
    SECURITY: { key: 'security', l10nKey: 'Security' },
    CHARGE: { key: 'charge', l10nKey: 'Charge' },
    WALLET: { key: 'wallet', l10nKey: 'Wallet' },
    CS: { key: 'cs', l10nKey: 'Inquiry' },
    HISTORY: { key: 'history', l10nKey: 'History' }
};

export const getShortcutDefaultList = (_rc, env) => {
    let defaultListData = {};
    let enterCouponData = {
        "isShow": true,
        "type": "popup",
        "popOption": "width=480,height=650,toolbar=0,menubar=0",
        "url": NSHOP_COUPON_DOMAIN[env || NETWORK.live]
    };
    if (userData.site==='lineagem') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/lms/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='bns2') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/bns2/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='tricksterm') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/tricksterm/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='h3') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/h3/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2m') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/l2m/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2mru') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/l2mru/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2mnu') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/l2mnu/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='h2') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/h2/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='linw') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/linw/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2mnct') {
        enterCouponData.url = `https://${_rc}tw.ncsoft.com/shop/l2m/tw/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }

    const shorcutArr = Object.entries(SHORTCUT);
    shorcutArr?.forEach(arr => {
        const shortcutValue = arr[1];

        const { key, l10nKey, iconClass } = shortcutValue || {};

        if(!key) {
            return;
        }

        defaultListData[key] = {
            isShow: false,
            type: '',
            url: '',
            popupName: '_blank',
            popOption: 'toolbar=0,menubar=0',
            name: '',
            params: {},
            l10nKey,
            title: '',
            iconClass: iconClass || key
        };
    });

    return {
        ...defaultListData,
        [SHORTCUT.MYPAGE.key]: {
            ...defaultListData[SHORTCUT.MYPAGE.key],
            isShow: true,
            url: `https://${_rc}id.plaync.com/index`
        },
        [SHORTCUT.NCOIN.key]: {
            ...defaultListData[SHORTCUT.NCOIN.key],
            isShow: true,
            type: 'popup',
            popOption: 'width=480,height=650,toolbar=0,menubar=0',
            url: `https://${_rc}orderform.plaync.com/wallet/charge?app=plaync&language=ko&country=KR`
        },
        [SHORTCUT.ENTER_COUPON.key]: {
            ...defaultListData[SHORTCUT.ENTER_COUPON.key], 
            ...enterCouponData
        },
        [SHORTCUT.CS.key]: {
            ...defaultListData[SHORTCUT.CS.key], 
            isShow: true,
            url: `https://${_rc}help.plaync.com/qna/list/ticket`
        }
    };
};